import blp from './blp';
import dds from './dds';
import { MappedData } from './mappeddata';
import jass2 from './jass2';
import mdlx from './mdlx';
import w3x from './w3x';

export default {
  blp,
  dds,
  MappedData,
  jass2,
  mdlx,
  w3x,
};
